<template>
  <dashboard-layout>
    <template #content />
  </dashboard-layout>
</template>

<script>
import { DashboardLayout } from '@/layouts';

export default {

  name: 'Settings',

  components: {
    DashboardLayout,
  },
};
</script>

<style lang="css" scoped>
</style>
